export const FACILITY_POTENTIAL_TYPES = [1, 2, 3];

export const FACILITY_ACTIVE_TYPE = 4;
